import React from "react";
/** Components Import */
import Section from "../../Components/Section";
import Card from "../../Components/Card_wrap";
import AuthGroupButton from "../../Components/Button_Auth_Group";
import BasicModal from "../../Components/Modal_Basic";
import Checking from "../../Components/Checking";
import DatePicker from "../../Components/Datepicker_Basic";
/** Ag-grid Import */
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import GridFunctions from "../../Services/agGrid/ag-Grid-functions";
import BasicButton from "../../Components/Button_Basic";
import BasicInput from "../../Components/Input_Basic";
import Commons from "../../Services/Common/Common";
function Sm10030(props) {
  React.useEffect(() => {
    document.title = "거래처/품목 납품현황";

    const element = document.getElementById("topbar");
    element.innerHTML =
      "<h1>" +
      "<span class='bullet'>" +
      "</span>" +
      "<strong class='depth-1'>" +
      "영업관리" +
      "	</strong>" +
      "<span class='divider' >" +
      "</span>" +
      "<strong'>거래처/품목 납품현황</strong>" +
      "</h1>";
  }, []);
  const gridRef = React.useRef();
  const columnDefs = [
    //사업장코드
    {
      field: "plantCd",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_PlantCd" && f.lanType === "COL"
            )[0].lanName
          : "",
      hide: true,
    },
    //사업장
    {
      field: "plantCd",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_PlantCd" && f.lanType === "COL"
            )[0].lanName
          : "",
      suppressSizeToFit: true,
      minWidth: 100,
      cellRenderer: Commons.CustomPlantRenderer,
    },

    //납품일자
    {
      field: "deliveryCheckDate",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_DelivDate" && f.lanType === "COL"
            )[0].lanName
          : "",
      suppressSizeToFit: true,
      minWidth: 100,
    },
    //품목명
    {
      field: "itemNm",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_ItemNm" && f.lanType === "COL"
            )[0].lanName
          : "",
      suppressSizeToFit: true,
      minWidth: 240,
    },

    //주문수량
    {
      field: "itemQty",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_OrderQty" && f.lanType === "COL"
            )[0].lanName
          : "",
      valueFormatter: (params) => {
        var formatted = params.value
          ? parseFloat(params.value)
              .toFixed(2)
              .toString()
              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
          : "";
        return formatted;
      },
      cellStyle: { textAlign: "right" },
      aggFunc: "sum",
      suppressSizeToFit: true,
      minWidth: 100,
    },

    //출하수량
    {
      field: "delivQty",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_ShipmentQuantity" && f.lanType === "COL"
            )[0].lanName
          : "",
      valueFormatter: (params) => {
        var formatted = params.value
          ? parseFloat(params.value)
              .toFixed(2)
              .toString()
              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
          : "";
        return formatted;
      },
      cellStyle: { textAlign: "right" },
      aggFunc: "sum",
      suppressSizeToFit: true,
      minWidth: 100,
    },
    //단가
    {
      field: "itemStdAmt",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_ItemStdAmt" && f.lanType === "COL"
            )[0].lanName
          : "",
      minWidth: 100,
      cellStyle: { textAlign: "right" },
    },
    //결제금액
    {
      field: "delivAmt",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_DelivAmt" && f.lanType === "COL"
            )[0].lanName
          : "",
      valueFormatter: (params) => {
        var formatted = params.value
          ? parseFloat(params.value)
              .toFixed(2)
              .toString()
              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
          : "";
        return formatted;
      },
      aggFunc: "sum",
      cellStyle: { textAlign: "right" },
      suppressSizeToFit: true,
      minWidth: 100,
    },
    //금액
    {
      field: "itemAmt",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_SoItemAmt" && f.lanType === "COL"
            )[0].lanName
          : "",
      valueFormatter: (params) => {
        var formatted = params.value
          ? parseFloat(params.value)
              .toFixed(2)
              .toString()
              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
          : "";
        return formatted;
      },
      aggFunc: "sum",
      cellStyle: { textAlign: "right" },
      suppressSizeToFit: true,
      minWidth: 100,
      hide: true,
    },
    //VAT
    {
      field: "itemVat",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_ItemVat" && f.lanType === "COL"
            )[0].lanName
          : "",
      valueFormatter: (params) => {
        var formatted = params.value
          ? parseFloat(params.value)
              .toFixed(2)
              .toString()
              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
          : "";
        return formatted;
      },
      cellStyle: { textAlign: "right" },
      aggFunc: "sum",
      minWidth: 110,
    },
    // //총금액
    // {
    //   field: "totalAmt",
    //   headerName:
    //     props.lanData.length > 0
    //       ? props.lanData.filter(
    //           (f) => f.lanId === "Col_TotalAmt" && f.lanType === "COL"
    //         )[0].lanName
    //       : "",
    //   valueFormatter: (params) => {
    //     var formatted = params.value
    //       ? parseFloat(params.value)
    //           .toFixed(2)
    //           .toString()
    //           .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
    //       : "";
    //     return formatted;
    //   },
    //   cellStyle: { textAlign: "right" },
    //   aggFunc: "sum",
    //   minWidth: 110,
    // },
    //적요
    {
      field: "remark",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_RemarkDtl" && f.lanType === "COL"
            )[0].lanName
          : "",
      suppressSizeToFit: true,
      minWidth: 100,
    },
    //제품규격
    {
      field: "itemStd",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_ItemStd1" && f.lanType === "COL"
            )[0].lanName
          : "",
      cellStyle: { textAlign: "center" },
      suppressSizeToFit: true,
      minWidth: 120,
    },
    //출하지시번호
    {
      field: "delivOrderNo",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_DelivOrderNo" && f.lanType === "COL"
            )[0].lanName
          : "",
      minWidth: 130,
    },
    //거래처명
    {
      field: "custNm",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_CustNm" && f.lanType === "COL"
            )[0].lanName
          : "",
      suppressSizeToFit: true,
      minWidth: 120,
    },
    //주소
    {
      field: "address",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_Address1" && f.lanType === "COL"
            )[0].lanName
          : "",
      suppressSizeToFit: true,
      minWidth: 210,
    },
    //연락처(이메일)
    {
      field: "eMail",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_Email" && f.lanType === "COL"
            )[0].lanName
          : "",
      suppressSizeToFit: true,
      minWidth: 190,
    },
    //품목코드
    {
      field: "itemCd",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_ItemCd" && f.lanType === "COL"
            )[0].lanName
          : "",
      suppressSizeToFit: true,
      minWidth: 100,
    },
  ];

  return (
    <div>
      <Section />
      <Card
        wrapStyle={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <DatePicker
            className={"datepicker-custom-input"}
            style={{ width: "120px", marginRight: "5px" }}
            selected={props.startDate}
            onChange={(e) => {
              props.setStartDate(e);
            }}
          />
          ~
          <DatePicker
            className={"datepicker-custom-input"}
            style={{ width: "120px", marginLeft: "5px" }}
            selected={props.endDate}
            onChange={(e) => {
              props.setEndDate(e);
            }}
          />
        </div>
        <AuthGroupButton
          pageName="SM10030"
          target="G01"
          refreshNone="none"
          refreshFunc={() => {
            props.Init();
          }}
          selectFunc={() => {
            props.Init();
          }}
        />
      </Card>
      <Section />
      <div
        className="ag-theme-alpine no-scroll"
        style={{ width: "100%", height: "770px" }}
      >
        <AgGridReact
          ref={gridRef}
          animateRows={true}
          columnDefs={columnDefs}
          groupIncludeTotalFooter={true}
          // autoSizeAll={autoSizeAll()}
          defaultColDef={{
            flex: 1,
            editable: false,
            resizable: true,
            sortable: true,
            filter: true,
            floatingFilter: true,
          }}
          cellDataType={false}
          onCellValueChanged={(e) =>
            GridFunctions.onCellValueChanged(
              e,
              gridRef,
              props.setChangedRowData
            )
          }
          rowData={props.rowData}
          rowSelection="single"
          onSelectionChanged={() =>
            GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData)
          }
          getRowStyle={(e) => (e.data ? GridFunctions.getRowStyle(e) : "")}
        />
      </div>
    </div>
  );
}

export default Sm10030;
